import { api } from '@shared-runtime/api';

import type {
  GetFiatUserAccessParams,
  GetFiatUserAccessResult,
} from './apiSchema';
import { normalizeGetFiatUserAccess } from './helpers';
import type { FiatUserAccessResponse } from './schema';

export async function fetchGetFiatUserAccess(
  params: GetFiatUserAccessParams,
): Promise<FiatUserAccessResponse> {
  return api.nts
    .get<GetFiatUserAccessResult>('/fiat/user-access-v2', { params })
    .normalize(normalizeGetFiatUserAccess);
}
